import { Sc4FailedMessagesListSearchCriteria } from '../../models';

export class Sc4FailedMessagesListLoad {
  public static readonly type = '[Sc4FailedMessagesList] Load';
  constructor(public payload: Sc4FailedMessagesListSearchCriteria) {}
}

export class Sc4FailedMessagesListInitialState {
  public static readonly type = '[Sc4FailedMessagesList] Set initial state';
}
